import { getCartAction } from "@/actions/cart";
import { getCartCookie } from "@/utils/cart/getCartCookie";

export async function fetchCart(locale: string) {
  const cartId = getCartCookie()?.value;

  if (!cartId) {
    return null;
  }

  return getCartAction({ locale, cartId });
}
